// BOD target groups (Màn hình / Thiết bị PC / Laptop / PERI split) for store consults.
// Single source: care-system/local-ai/config/target_groups.json — the same file renders the local
// model's category block, so the dashboard and the classifier cannot drift apart.
import config from '../../local-ai/config/target_groups.json';

interface TargetRecord {
  ai_category?: string | null;
  ai_subcategory?: string | null;
  ai_need_type?: string | null;
}

const BY_CATEGORY = config.by_category as Record<string, string>;
const BY_SUBCATEGORY = config.by_subcategory as Record<string, string>;

export const TARGET_GROUPS = config.groups;
export const TARGET_PARENTS = config.parents;
export const TARGET_LABEL: Record<string, string> = Object.fromEntries(
  [...config.groups, ...config.parents].map(g => [g.code, g.label]),
);
export const TARGET_PARENT_OF: Record<string, string> = Object.fromEntries(config.groups.map(g => [g.code, g.parent]));
export const TARGET_CHILDREN: Record<string, string[]> = Object.fromEntries(
  config.parents.map(p => [p.code, config.groups.filter(g => g.parent === p.code).map(g => g.code)]),
);
// The four sales targets; SVC/OTHER never carry a close rate.
export const SALES_PARENTS = ['LCD', 'PCD', 'LTD', 'PED'];

export const TARGET_COLOR: Record<string, string> = {
  LCD: '#7c3aed', PCD: '#2563eb', LTD: '#0891b2', PED: '#d97706',
  PED_KB: '#d97706', PED_MOUSE: '#ea580c', PED_HEADSET: '#ca8a04', PED_CHAIR: '#16a34a', PED_OTHER: '#94a3b8',
  SVC: '#64748b', OTHER: '#94a3b8',
};

export function targetOf(r: TargetRecord): string {
  if ((r.ai_need_type || '').toLowerCase() === 'service') return 'SVC';
  const sub = (r.ai_subcategory || '').trim().toUpperCase();
  if (sub && BY_SUBCATEGORY[sub]) return BY_SUBCATEGORY[sub];
  return BY_CATEGORY[(r.ai_category || '').trim().toUpperCase()] || 'OTHER';
}

export const parentOf = (r: TargetRecord): string => TARGET_PARENT_OF[targetOf(r)] || 'OTHER';
